/* Scroll position is the only animation clock: no idle motion or trailing easing. */
(() => {
  window.GrovaSections.register('grova-ingredients-motion', '[data-ingredients-motion]', (root, scope) => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 767px)');
    const mushrooms = [
      { element: root.querySelector('.gnp-science__decor--chaga'), edge: 'top', x: 5, y: 18, rotation: 3 },
      { element: root.querySelector('.gnp-science__decor--mane'), edge: 'bottom', x: -7, y: 26, rotation: -4 },
    ].filter(item => item.element);
    if (!mushrooms.length) return;
    let frame = null;
    let visible = true;
    let disposed = false;
    const properties = ['--mushroom-x', '--mushroom-y', '--mushroom-rotation'];
    function reset() {
      cancelAnimationFrame(frame);
      frame = null;
      mushrooms.forEach(({ element }) => properties.forEach(property => element.style.removeProperty(property)));
    }
    function update() {
      frame = null;
      if (disposed || !visible || reducedMotion.matches) return;
      // Read the stable section edges, never the transformed cutouts themselves.
      const bounds = root.getBoundingClientRect();
      const viewport = window.innerHeight || 1;
      const scale = mobile.matches ? .35 : 1;
      mushrooms.forEach(({ element, edge, x, y, rotation }) => {
        const progress = Math.max(-1, Math.min(1, (viewport / 2 - bounds[edge]) / (viewport / 2 + 160)));
        const amount = progress * scale;
        element.style.setProperty('--mushroom-x', `${(amount * x).toFixed(3)}px`);
        element.style.setProperty('--mushroom-y', `${(amount * y).toFixed(3)}px`);
        element.style.setProperty('--mushroom-rotation', `${(amount * rotation).toFixed(3)}deg`);
      });
    }
    function schedule() {
      if (disposed || !visible || reducedMotion.matches || frame !== null) return;
      frame = requestAnimationFrame(update);
    }
    scope.on(window, 'scroll', schedule, { passive: true });
    scope.on(window, 'resize', schedule);
    scope.on(mobile, 'change', schedule);
    scope.on(reducedMotion, 'change', () => { reset(); schedule(); });
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
        if (visible) schedule();
      }, { rootMargin: '200px 0px' });
      observer.observe(root);
      scope.cleanup(() => observer.disconnect());
    }
    schedule();
    scope.cleanup(() => { disposed = true; reset(); });
  });
})();
